export default {
    affected: {
        name: "Affected",
        url: "sarcop_damage_observations/affected",
    },
    destroyed: {
        name: "Destroyed",
        url: "sarcop_damage_observations/destroyed",
    },
    major: {
        name: "Major",
        url: "sarcop_damage_observations/major",
    },
    minor: {
        name: "Minor",
        url: "sarcop_damage_observations/minor",
    },
    unaffected: {
        name: "Unaffected",
        url: "sarcop_damage_observations/unaffected",
    },
    unknown: {
        name: "Unknown",
        url: "sarcop_damage_observations/unknown",
    },
}
